module.exports = __webpack_public_path__ + "img/stock4.8c534be1.png";